"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payrollPatchConfigSchema = exports.payrollPostConfigSchema = void 0;
const zod_1 = require("zod");
const inputJsonSchema = zod_1.z
    .unknown()
    .refine(v => {
    try {
        if (!v || typeof v !== 'object')
            return false;
        JSON.parse(JSON.stringify(v));
        return true;
    }
    catch (e) {
        return false;
    }
}, {
    message: 'Invalid JSON schema',
})
    .transform(v => v);
const statusFlowConfigSchema = zod_1.z
    .unknown()
    .refine(v => {
    try {
        if (!v || typeof v !== 'object')
            return false;
        JSON.parse(JSON.stringify(v));
        return true;
    }
    catch (e) {
        return false;
    }
}, {
    message: 'Invalid Status Flow Config',
})
    .transform(v => v);
const commonSchema = zod_1.z.object({
    name: zod_1.z.string().min(1),
    status_flow_config: statusFlowConfigSchema,
});
const paymentRequestConfigSchema = zod_1.z.object({
    input_schema: inputJsonSchema,
    payment_request_config: zod_1.z.object({
        group_by_metadata: zod_1.z.array(zod_1.z.string()).min(1),
        minimum_payment_ask: zod_1.z.number().default(0),
    }),
});
exports.payrollPostConfigSchema = zod_1.z.discriminatedUnion('graph_type', [
    commonSchema.merge(zod_1.z.object({
        graph_type: zod_1.z.literal('payroll'),
        config: zod_1.z.object({}).optional(),
    })),
    commonSchema.merge(zod_1.z.object({
        graph_type: zod_1.z.literal('payment_request'),
        config: paymentRequestConfigSchema,
    })),
]);
exports.payrollPatchConfigSchema = zod_1.z.object({
    name: zod_1.z.string().optional(),
    status_flow_config: zod_1.z.any(),
    config: paymentRequestConfigSchema.optional(),
    status_normalization: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).optional(),
});
